import React, {useEffect, useRef, useState} from "react";
import {Button, Form} from "react-bootstrap";
import {PriceSettingSet} from "./PriceSettingSet";
import max from 'lodash/max';
import {LABELS} from "./constants";
import {csrfParam, csrfToken} from "../lib/utils";

export const PriceSettingsSets = (props) => {
    const mounted = useRef(false);
    const [prices, setPrices] = useState([]);
    const {url} = props;

    useEffect(() => {
        if (!mounted.current) {
            const data = JSON.parse(props.data || '{settings:[]}');
            if (data.prices) {
                data.settings = [{
                    prices: data.prices,
                    enabled: true,
                }];
            }
            if (data.settings.length === 0) {
                data.settings.push({type: 'unspecified', enabled: true, prices: [{}]});
            }
            setPrices(data.settings);
        }
        return () => {
            mounted.current = true;
        }
    }, []);

    const addPriceSetting = () => {
        setPrices([...prices, {enabled: true, type: 'unspecified'}]);
    };
    const onDeleteItem = index => {
        prices.splice(index, 1);
        setPrices([...prices]);
    };

    const onSettingsChanged = (index, value) => {
        const price = prices[index];
        prices.splice(index, 1, {...price, ...value});
        setPrices([...prices]);
    };
    const duplicateTypesCheck = () => {
        const settings = {};
        prices.forEach(setting => {
            if (setting.enabled && setting.prices?.length > 0) {
                settings[setting.type] ||= 0;
                settings[setting.type] += 1;
            }
        });

        return settings;
    };

    const duplicateErrorMessage = settings => {
        const messages = [];
        for (const key in settings) {
            const value = settings[key];
            messages.push(`${LABELS[key]}の有効な設定が${value}個あります`)
        }
        return messages.join("\n");
    };

    const onClick = (e) => {
        const settings = duplicateTypesCheck();
        console.log(settings);
        if ((max(Object.values(settings)) || 0) > 1) {
            e.preventDefault();
            alert(duplicateErrorMessage(settings));
            return false;
        }
        return true;
    };
    return <Form validated={true} action={url} method="POST" data-remote={true}>
        <input name='_method' type='hidden' value={props.action}/>
        <input type='hidden' name={csrfParam()} value={csrfToken()} />
        <div className="mb-4 pt-3">
            <div className="d-flex">
                <h2>自動価格設定</h2>
                <span className="flex-fill"/>
                <input type="submit" value="保存" className="btn btn-success" onClick={onClick}/>
            </div>
            {
                prices.some(x => x.enabled && x.prices?.length > 0) ? '' : <label className="error">有効な価格設定がありません。価格設定を行ってください</label>
            }
        </div>
        <ul>
            {
                prices.map((props, i) =>
                    <li key={`price-setting-set-${i}`} className="price-settings-set-container">
                        <PriceSettingSet index={i} {...props} onDeleteItem={onDeleteItem} onSettingsChanged={onSettingsChanged} />
                    </li>
                )
            }
        </ul>
        <Button variant="primary" onClick={addPriceSetting}>価格設定を追加</Button>
    </Form>;
}